import { ArrowUpRight } from "lucide-react";
import { LOGO_MARK } from "../data/eventData";
import { MaskLine, Reveal } from "./Motion";

export default function FinalCTA({ onCTA }) {
  return (
    <section className="relative py-28 sm:py-40 overflow-hidden grain" data-testid="final-cta">
      {/* Watermark mark */}
      <img
        src={LOGO_MARK}
        alt=""
        aria-hidden="true"
        className="absolute -right-24 top-1/2 -translate-y-1/2 h-[420px] w-auto opacity-[0.07] pointer-events-none animate-float-slow"
      />
      <div className="absolute inset-0 bg-[radial-gradient(900px_480px_at_30%_50%,rgba(0,142,255,0.16),transparent_65%)] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-[-0.02em] max-w-4xl" data-testid="final-cta-heading">
          <MaskLine inView>O palco está pronto.</MaskLine>
          <MaskLine inView delay={0.12}>
            <span className="text-gradient-blue">Falta você.</span>
          </MaskLine>
        </h2>
        <Reveal delay={0.25}>
          <p className="mt-6 max-w-lg text-brand-silver/75 leading-relaxed">
            Garanta sua vaga no Pregoeiros Summit 2027 e viva três dias que vão transformar a forma como você conduz
            licitações e contratos.
          </p>
          <div className="mt-10">
            <button onClick={onCTA} className="btn-primary text-base !px-10 !py-4" data-testid="final-cta-button">
              Quero garantir minha vaga <ArrowUpRight size={18} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
